import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistBoolFieldModule',
  props: {
    pId: { type: String, required: true },
    isDisabled: { type: Boolean, default: false },
    activeProductFormId: { type: Number, default: null },
    debounceToggleIsActive: {
        type: Function as PropType<(state: boolean) => void>,
        default: null,
    },
},
  emits: ['updateStoreFieldValue'],
  setup(__props, { emit }) {

const props = __props;





const value = ref(false);

const fieldValue = computed(() => {
    if (props.activeProductFormId == null) {
        return false;
    }

    return store.getters['configurator/activeProductFormValue'](props.pId, props.activeProductFormId) as boolean | null;
});

function onChange(checked: boolean) {
    if (props.activeProductFormId == null) {
        value.value = checked;
    }

    EventBus.$emit(EventBusEvents.changesInDataMade, { state: true });

    emit(EventBusEvents.updateStoreFieldValue, {
        pId: props.pId,
        value: checked,
        productFormId: props.activeProductFormId,
    });
}

function onBlur() {
    props.debounceToggleIsActive?.(false);
}

function onFocus() {
    window.setTimeout(() => {
        props.debounceToggleIsActive?.(true);
    }, 200);
}

watch(
    fieldValue,
    (newValue: boolean | null) => {
        if (newValue == null) {
            value.value = false;
            return;
        }
        value.value = newValue;
    },
    { immediate: true },
);

return { __sfc: true,props, emit, value, fieldValue, onChange, onBlur, onFocus }
}

})